import { createContext, useCallback, useContext, useState } from 'react';

const OnboardingDataContext = createContext({
  setOnboardingContext: () => {},
});

export const OnboardingDataProvider = ({ children }) => {
  const [OnboardingContext, setOnboardingContext] = useState({});
  const [arrowContext, setArrrowContext] = useState(false);
  // const [answerSave, setAnswerSave] = useState({});
  const [selectedAgeUser, setSelectedAge] = useState();

  // for showing the user red next cta
  const setArrowFunction = useCallback((data, input) => {
    setArrrowContext(data);
    if (input === '' || input < 19) {
      setArrrowContext(false);
    }
    //for age year question
    if (input >= 19) {
      setArrrowContext(true);
    }
  }, []);

  const setSelectedAgeFunction = useCallback(data => {
    setSelectedAge(data);
  }, []);

  const setOnboardingDataContext = useCallback(value => {
    if (!value) {
      return;
    }
    setOnboardingContext(value);
  }, []);

  return (
    <OnboardingDataContext.Provider
      value={{
        arrowContext,
        OnboardingContext,
        selectedAgeUser,
        setOnboardingDataContext,
        setArrowFunction,
        setSelectedAgeFunction,
      }}
    >
      {children}
    </OnboardingDataContext.Provider>
  );
};

export const useOnboardingDataContext = () => useContext(OnboardingDataContext);
